import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { Box } from 'foundations-components/transitional/components/Box';
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const SharingListItem = ({
  avatar,
  primaryText,
  secondaryText,
  badge,
  testId
}) => {
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    gap: "300",
    paddingBlock: "200",
    "data-test-id": testId,
    children: [avatar, /*#__PURE__*/_jsxs(Box, {
      grow: 1,
      minInlineSize: "0",
      children: [/*#__PURE__*/_jsx(Text, {
        typography: "body-100",
        color: "text-core-default",
        children: /*#__PURE__*/_jsx(TruncateString, {
          children: primaryText
        })
      }), secondaryText && /*#__PURE__*/_jsx(Text, {
        typography: "detail-100",
        color: "text-core-subtle",
        children: /*#__PURE__*/_jsx(TruncateString, {
          children: secondaryText
        })
      })]
    }), badge]
  });
};